import Cookies from 'js-cookie';
import { DBManager } from '_c/business/storage';
import { UserManager } from '_c/business/manager/user';

/**
 * 清空cookie信息
 */
export function clearCookies(): void {
  const keys = document.cookie.match(/[^ =;]+(?==)/g);
  if (keys) {
    const path = '/';
    const domain = '.noknok.cn';
    for (let i = 0; i < keys.length - 1; i++) {
      Cookies.remove(keys[i], { domain, path });
    }
  }
}

/**
 * 退出登录，清空用户信息
 */
export function logoutAndClearUserInfo() {
  clearCookies();
  window.localStorage.clear();
  window.sessionStorage.clear();
  DBManager.getInstance()?.restart();
  UserManager.getInstance().clearCurrentUid();
  window.location.href = '/login';
}
